//sadnand_gadwal
export const GET_BOOKING = "GET_BOOKING";
export const GET_CUSTOMER_ORGANIZATION = "GET_CUSTOMER_ORGANIZATION";
export const GET_CUSTOMER_WORK_EXPERIENCE = "GET_CUSTOMER_WORK_EXPERIENCE";
export const GET_CUSTOMER_WORK_SECTOR = "GET_CUSTOMER_WORK_SECTOR";
export const GET_CUSTOMER_INCOME = "GET_CUSTOMER_INCOME";
export const GET_CUSTOMER_WORK_FUNCTION = "GET_CUSTOMER_WORK_FUNCTION";
export const GET_ENQUIRY_SOURCE = "GET_ENQUIRY_SOURCE";
export const GET_ENQUIRY_SOURCE_NEWSPAPER = "GET_ENQUIRY_SOURCE_NEWSPAPER";
export const GET_ENQUIRY_SOURCE_SOCIAL_MEDIA =
  "GET_ENQUIRY_SOURCE_SOCIAL_MEDIA";
export const GET_CUSTOMER_EMPLOYMENT_TYPE = "GET_CUSTOMER_EMPLOYMENT_TYPE";
export const GET_CUSTOMER_CURRENT_LIVING = "GET_CUSTOMER_CURRENT_LIVING";
export const GET_CUSTOMER_CRITICAL_FACTOR = "GET_CUSTOMER_CRITICAL_FACTOR";
export const GET_CUSTOMER_SUITABLE_TIME = "GET_CUSTOMER_SUITABLE_TIME";

//sales inkvoice
export const GET_SALES_ORDER_ITEM = "GET_SALES_ORDER_ITEM";
export const GET_SALES_INVOICE = "GET_SALES_INVOICE";
export const GET_SALES_INVOICE_FILTER_COMPANY =
  "GET_SALES_INVOICE_FILTER_COMPANY";
export const GET_SALES_INVOICE_DETAIL = "GET_SALES_INVOICE_DETAIL";

//sales accounting
export const GET_SALES_ACCOUNTNG = "GET_SALES_ACCOUNTNG";
export const GET_SALES_ACCOUNTNG_EXPORT = "GET_SALES_ACCOUNTNG_EXPORT";
export const GET_SALES_ACCOUNTNG_FILTER_PROJECT =
  "GET_SALES_ACCOUNTNG_FILTER_PROJECT";
export const GET_SALES_ACCOUNTNG_DETAIL = "GET_SALES_ACCOUNTNG_DETAIL";
export const GET_SALES_ACCOUNTNG_FOR_INOVICE =
  "GET_SALES_ACCOUNTNG_FOR_INOVICE";
export const GET_SALES_INVOICE_FILTER_PROJECT =
  "GET_SALES_INVOICE_FILTER_PROJECT";
export const GET_SALES_ORDER_PAYMENT_SCHEDULE =
  "GET_SALES_ORDER_PAYMENT_SCHEDULE";
export const GET_REFERRAL_FOR_SALES_ORDER = "GET_REFERRAL_FOR_SALES_ORDER";
// -----------------------CLP-----------------------------

// --------------------------------END-CLP--------------------------------------------

//Customer
export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMER_EXPORT = "GET_CUSTOMER_EXPORT";
export const GET_CUSTOMER_DETAIL = "GET_CUSTOMER_DETAIL";

//Sales Plan
export const GET_ITEM_FOR_SALES_PLAN = "GET_ITEM_FOR_SALES_PLAN";
export const GET_SALES_PLAN = "GET_SALES_PLAN";
export const GET_SALES_PLAN_EXPORT = "GET_SALES_PLAN_EXPORT";
export const GET_SALES_PLAN_DETAILS = "GET_SALES_PLAN_DETAILS";
export const GET_MARKETING_PLAN_ITEM = "GET_MARKETING_PLAN_ITEM";

export const GET_SALES_INVOICE_EXPORT = "GET_SALES_INVOICE_EXPORT";

//Sales Referral
export const GET_SALES_REFERRAL = "GET_SALES_REFERRAL";
export const GET_SALES_REFERRAL_EXPORT = "GET_SALES_REFERRAL_EXPORT";
export const GET_SALES_REFERRAL_DETAIL = "GET_SALES_REFERRAL_DETAIL";
export const GET_SALES_REFERRAL_FILTER_PROJECT =
  "GET_SALES_REFERRAL_FILTER_PROJECT";
export const GET_SALES_REFERRAL_PRINT = "GET_SALES_REFERRAL_PRINT";
export const GET_SALES_REFERRAL_BILL_FILTER_PROJECT =
  "GET_SALES_REFERRAL_BILL_FILTER_PROJECT";
export const GET_SALES_REFERRAL_BILL_FILTER_COMPANY =
  "GET_SALES_REFERRAL_BILL_FILTER_COMPANY";
export const GET_SALES_REFERRAL_BILL_FILTER_VENDOR =
  "GET_SALES_REFERRAL_BILL_FILTER_VENDOR";
export const GET_SALES_REFERRAL_BILL = "GET_SALES_REFERRAL_BILL";
export const GET_SALES_REFERRAL_BILL_EXPORT = "GET_SALES_REFERRAL_BILL_EXPORT";
export const GET_ITEM_FOR_SALES_REFERRAL = "GET_ITEM_FOR_SALES_REFERRAL";
export const GET_SALES_REFERRAL_FILTER_REFERRER =
  "GET_SALES_REFERRAL_FILTER_REFERRER";
export const GET_SALES_REFERRAL_BILL_DETAIL = "GET_SALES_REFERRAL_BILL_DETAIL";
export const GET_SALES_REFFERAL_LIST = "GET_SALES_REFFERAL_LIST";
export const GET_SALES_REFFERAL_CP_LIST = "GET_SALES_REFFERAL_CP_LIST";
//land consultant
export const GET_LAND_CONSULTANT = "GET_LAND_CONSULTANT";
export const CREATE_LAND_CONSULTANT = "CREATE_LAND_CONSULTANT";
export const GET_LAND_CONSULTANT_EXPORT = "GET_LAND_CONSULTANT_EXPORT";
export const GET_LAND_CONSULTANT_DETAIL = "GET_LAND_CONSULTANT_DETAIL";

//Live Booking
export const GET_ENQUIRY_MATCH_LIST = "GET_ENQUIRY_MATCH_LIST";
export const GET_PROJECT_FOR_SALES_ORDER = "GET_PROJECT_FOR_SALES_ORDER";
export const GET_SITE_FOR_BOOKING = "GET_SITE_FOR_BOOKING";
export const GET_SITE_COST_FOR_BOOKING = "GET_SITE_COST_FOR_BOOKING";
export const GET_CUSTOMER_INFO_FOR_BOOKING = "GET_CUSTOMER_INFO_FOR_BOOKING";
export const GET_SALES_BOOKING = "GET_SALES_BOOKING";
export const GET_SALES_BOOKING_EXPORT = "GET_SALES_BOOKING_EXPORT";
export const GET_SITE_SELECTION_DETAIL_FOR_BOOKING =
  "GET_SITE_SELECTION_DETAIL_FOR_BOOKING";
export const GET_SALES_BOOKING_DETAILS = "GET_SALES_BOOKING_DETAILS";

//Sales Order
export const GET_LEAD_FOR_SALES_ORDER = "GET_LEAD_FOR_SALES_ORDER";
export const GET_LEAD_DETAIL_FOR_SALES_ORDER =
  "GET_LEAD_DETAIL_FOR_SALES_ORDER";
export const GET_PROJECT_FOR_SALES_ORDER1 = "GET_PROJECT_FOR_SALES_ORDER1";
export const GET_SITE_FOR_SALES_ORDER = "GET_SITE_FOR_SALES_ORDER";
export const GET_FACING_FOR_SALES_ORDER = "GET_FACING_FOR_SALES_ORDER";
export const GET_DIMENSION_FOR_SALES_ORDER = "GET_DIMENSION_FOR_SALES_ORDER";
export const GET_SITE_DETAIL_FOR_SALES_ORDER =
  "GET_SITE_DETAIL_FOR_SALES_ORDER";
export const GET_SALES_ORDER = "GET_SALES_ORDER";
export const GET_SALES_ORDER_EXPORT = "GET_SALES_ORDER_EXPORT";
export const GET_SALES_ORDER_DETAIL = "GET_SALES_ORDER_DETAIL";
export const GET_CUSTOMER_DETAIL_FOR_SALES_ORDER =
  "GET_CUSTOMER_DETAIL_FOR_SALES_ORDER";
export const GET_CUSTOMER_DETAIL_FOR_SALES_ORDER_FOR_APPLICANT =
  "GET_CUSTOMER_DETAIL_FOR_SALES_ORDER_FOR_APPLICANT";
export const GET_RELATIONSHIP_FOR_SALES_ORDER =
  "GET_RELATIONSHIP_FOR_SALES_ORDER";
export const GET_SALES_ORDER_CUSTOMER = "GET_SALES_ORDER_CUSTOMER";

export const CREATE_SALES_ORDER = "CREATE_SALES_ORDER";
export const CREATE_CUSTOMER_FOR_SALES_ORDER =
  "CREATE_CUSTOMER_FOR_SALES_ORDER";

//Sales Cancellation
export const GET_SALES_CANCELLATION = "GET_SALES_CANCELLATION";
export const GET_SALES_CANCELLATION_EXPORT = "GET_SALES_CANCELLATION_EXPORT";
export const GET_SALES_CANCELLATION_DETAIL = "GET_SALES_CANCELLATION_DETAIL";
export const GET_SALES_CANCELLATION_FILTER_PROJECT =
  "GET_SALES_CANCELLATION_FILTER_PROJECT";
export const GET_SALES_CANCELLATION_FILTER_SITE =
  "GET_SALES_CANCELLATION_FILTER_SITE";
export const GET_SALES_CANCELLATION_FILTER_STATUS =
  "GET_SALES_CANCELLATION_FILTER_STATUS";

// Sales Incentive
export const GET_SALES_INCENTIVE = "GET_SALES_INCENTIVE";
export const GET_SALES_INCENTIVE_EXPORT = "GET_SALES_INCENTIVE_EXPORT";
export const GET_SALES_INCENTIVE_DETAIL = "GET_SALES_INCENTIVE_DETAIL";

// Presales Incentive
export const GET_PRESALES_INCENTIVE = "GET_PRESALES_INCENTIVE";
export const GET_PRESALES_INCENTIVE_EXPORT = "GET_PRESALES_INCENTIVE_EXPORT";
export const GET_PRESALES_INCENTIVE_DETAIL = "GET_PRESALES_INCENTIVE_DETAIL";

// Sales Referal Slab
export const GET_SALES_REFERRAL_SLAB = "GET_SALES_REFERRAL_SLAB";
export const GET_SALES_REFERRAL_SLAB_EXPORT = "GET_SALES_REFERRAL_SLAB_EXPORT";
